import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  costFormater,
  FieldWrapper,
  Label,
  RadioButton,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import { IReturnedCheckDto } from '@/dtos/models';

import { CheckDecision, CheckProcessingType } from '../returnedChecks.types';

interface Props {
  check: IReturnedCheckDto;
  decision?: CheckDecision;
  onSelect: (lockboxId: number, type: CheckProcessingType) => void;
}

const ReturnedProviderCheckCard: React.FC<Props> = ({ check, decision, onSelect }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const lockboxId = check.lockbox_id as number;
  const testIdBase = `returned-check_provider_${lockboxId}`;

  return (
    <Box
      pad={isMobile ? 'spacing16' : 'spacing24'}
      background="canvas"
      round="container1Round"
      border={{ color: 'border2', size: '1px' }}
      gap="spacing16"
      data-testid={testIdBase}
    >
      <Text size="large" color="textBody" data-testid={`${testIdBase}_title`}>
        {t('Returned Provider Check')} ({costFormater(check.check_amount ?? 0, true)})
      </Text>

      <FieldWrapper direction={isMobile ? 'column' : 'row'} align={isMobile ? 'stretch' : 'center'}>
        <Label name={`${testIdBase}_pay-to`} isNarrow={!isMobile}>
          {t('Pay to')}
        </Label>
        <Text color="textBody" data-testid={`${testIdBase}_pay-to-value`}>
          {check.pay_to || '-'}
        </Text>
      </FieldWrapper>

      <FieldWrapper direction={isMobile ? 'column' : 'row'} align="start">
        <Label name={`${testIdBase}_action`} isNarrow={!isMobile} showRequireIcon>
          {t('Take action')}
        </Label>
        <Box gap="spacing12">
          <RadioButton
            data-testid={`${testIdBase}_void-action`}
            name={`${testIdBase}_action`}
            checked={decision?.type === CheckProcessingType.VOID}
            onChange={() => onSelect(lockboxId, CheckProcessingType.VOID)}
            label={(
              <Box height="24px" align="center">
                <Text color="textBody" margin={{ vertical: 'auto' }}>
                  {t('Void & return to my account')}
                </Text>
              </Box>
            )}
          />
          <RadioButton
            data-testid={`${testIdBase}_reissue-action`}
            name={`${testIdBase}_action`}
            checked={decision?.type === CheckProcessingType.REISSUE}
            onChange={() => onSelect(lockboxId, CheckProcessingType.REISSUE)}
            label={(
              <Box height="24px" align="center">
                <Text color="textBody" margin={{ vertical: 'auto' }}>
                  {t('Re-issue')}
                </Text>
              </Box>
            )}
          />
        </Box>
      </FieldWrapper>
    </Box>
  );
};

export default ReturnedProviderCheckCard;
